import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import LockIcon from '@mui/icons-material/Lock';
import {Box, SxProps, Typography} from '@mui/material';

import {EmpionButton} from '../EmpionButton/EmpionButton';

import {useUserData} from '../../contexts/UserContext/useUserData';
import {greenColors} from '../../layouts/theme/designSystem';
import {AppConfig} from '../../lib/AppConfig';
import {ApplicantRoleData} from '../../types/User';

interface Props {
  src?: string;
  isMobile?: boolean;
  isXsmall?: boolean;
  sx?: SxProps;
}

export const CultureTypeImage = ({src, sx, isMobile, isXsmall}: Props) => {
  const {t} = useTranslation();
  const {currentUser} = useUserData();
  const navigate = useNavigate();

  const onClick = () => {
    const surveyId = (currentUser?.role.data as ApplicantRoleData).talentSurveyId;

    if (surveyId) {
      navigate(`${AppConfig.TALENT_SURVEY_WITH_ID_PATH}/${surveyId}`);
    }
  };

  if (!src) {
    return (
      <Box
        width='224px'
        height={isMobile ? 'auto' : '224px'}
        display='flex'
        alignItems='center'
        flexDirection='column'
        justifyContent='center'
      >
        <Box display='flex' alignItems='center' flexDirection='column' justifyContent='center'>
          <LockIcon
            sx={{
              fontSize: '80px',
              color: greenColors[40],
              marginBottom: isXsmall ? '0px' : '24px',
              marginTop: isMobile ? '25px' : '0px',
            }}
          />
          {!isMobile && (
            <EmpionButton onClick={onClick}>
              <Typography sx={{color: 'white'}} variant='h4'>
                {t('applicantCultureTypeBanner.applicant.button')}
              </Typography>
            </EmpionButton>
          )}
        </Box>
      </Box>
    );
  }
  return (
    <Box
      component='img'
      src={src}
      alt='culture type image'
      sx={{...sx, objectFit: 'contain'}}
      maxHeight={'224px'}
      maxWidth={'224px'}
    />
  );
};
